import { SxProps } from '@mui/material/styles';
import { Box, Stack, styled } from '@mui/material';
import { tGridTemplateColumns } from '../../react-pages/HomePage/OurProducts/OurProducts';
import LocalizedLink from '../Link/localized-link';

interface ICardImage {
  columns?: string;
}

export const CardStyled = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1),
  position: 'relative',
  [theme.breakpoints.down('md768')]: {
    gap: '2px',
  },
  ':hover': {
    '& .wishlist-icon': {
      visibility: 'visible !important',
    },
  },
}));

export const WrapperLink = styled(LocalizedLink)(() => ({
  width: '100%',
  maxWidth: '30rem',
  margin: '0 auto',
}));

export const CardDetailsStyled = styled(Box)(() => ({}));

export const CardTagsStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  minHeight: theme.spacing(3),
}));

export const CardImageStyled = styled(Box)<ICardImage>(({ theme, columns }) => ({
  display: 'flex',
  justifyContent: 'center',
  background: '#fafafa',
  overflow: 'hidden',
  borderRadius: '4px',
  xs: {
    width: columns === '1fr 1fr' ? '178px' : '335px',
    height: columns === '1fr 1fr' ? '182px' : '331px',
  },
  md: { width: '292px', height: '400px' },
}));

export const getStyles = ({ columns, imageHeight }: { columns: tGridTemplateColumns; imageHeight?: number }) => {
  return {
    CardMedia: {
      transition: 'transform .2s',
      objectFit: 'cover',
      height: {
        xs: columns === '1fr 1fr' ? '238.93px' : '400px',
        md: imageHeight ? `${imageHeight}px` : '400px',
      },
      ':hover': {
        transform: { xs: 'scale(1)', md: 'scale(1.16)' },
      },
    },
  } as {
    [key: string]: SxProps;
  };
};

export const CardDescription = styled(Box)(() => ({}));
